import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { passing_draw_line_string as drawLineString } from "mapbox-gl-draw-passing-mode";

const {
  constants: Constants,
  lib: { doubleClickZoom },
} = MapboxDraw;

const streetView: DrawCustomMode = {
  ...drawLineString,

  /**
   * We restrict the lineString to only 2 points.
   */
  onClick: function (state, e) {
    drawLineString.onClick?.call(this, state, e);
    if (state.line.coordinates.length === 3) {
      this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
    }
  },

  /**
   * We customize the onStop function to fire a custom map event to allow for handling independent
   * of the draw handlers using the passing mode.
   */
  onStop: function (state) {
    const f = state.line;

    this.updateUIClasses({ mouse: Constants.cursors.NONE });
    doubleClickZoom.enable(this);
    this.activateUIButton();

    // check to see if we've deleted this feature
    const drawnFeature = this.getFeature(f.id);
    if (drawnFeature === undefined) {
      // Call `onCancel` if exists.
      if (typeof state.onCancel === "function") state.onCancel();
      return;
    } else {
      // remove last added coordinate
      f.removeCoordinate(`${state.currentVertexPosition}`);
    }

    if (f.isValid()) {
      if (typeof state.onDraw === "function") state.onDraw(f.toGeoJSON());
      else
        this.map.fire("draw.street-view", {
          features: [f.toGeoJSON()],
        });
    }
    this.deleteFeature(f.id, { silent: true });
    this.changeMode(Constants.modes.SIMPLE_SELECT, {}, { silent: true });
  },

  // We add a street_view property to the feature to allow for styling.
  toDisplayFeatures(state, geojson, display) {
    const isActiveLine = geojson.properties.id === state.line.id;
    if (isActiveLine) {
      geojson.properties.street_view = Constants.activeStates.ACTIVE;
    }
    display(geojson);
  },
};

export default streetView;
